import { FC } from 'react';
import StyledText, { TextSize, TextStyle } from '../../../../shared/StyledText/StyledText';
import Loader from '../../../../shared/Loader/Loader';
import ProductsLoader from '../../../../shared/ProductsLoader/ProductsLoader';
import { useInjection } from '../../../../../dependancyInjection/DependencyContext';
import { DisplayOnlyOrchestratorService } from '../../../../../services/DisplayOnlyOrchestratorService/DisplayOnlyOrchestratorService';
import DependencyType from '../../../../../dependancyInjection/DependencyType';
import BaseServiceScreen from '../../../../shared/ServiceScreens/BaseServiceScreen/BaseServiceScreen';
import { FunctionalComponentWithChildren } from '../../../../../FCWithChildren';

export interface DisplayOnlyLoadingScreenProps {
    type: 'products' | 'state';
    onSetupComplete?: () => void;
}

const DisplayOnlyLoadingScreen: FunctionalComponentWithChildren<DisplayOnlyLoadingScreenProps> = props => {
    const displayOnlyOrchestrator = useInjection<DisplayOnlyOrchestratorService>(
        DependencyType.DisplayOnlyOrchestratorService,
    );

    return (
        <BaseServiceScreen>
            <StyledText style={TextStyle.Heading} size={TextSize.Large} className={'DisplayOnlyLoadingScreen__text'}>
                Just a moment
            </StyledText>
            <StyledText
                style={TextStyle.Subheading}
                size={TextSize.Small}
                className={`DisplayOnlyLoadingScreen__text .DisplayOnlyLoadingScreen__info`}
            >
                {props.type === 'products' && <>Cloudshelf Display is loading your products</>}
                {props.type === 'state' && <>Cloudshelf Display is populating the display state</>}
            </StyledText>
            {props.type === 'state' && <Loader variant="light" className={'DisplayOnlyLoadingScreen__loader'} />}
            {props.type === 'products' && (
                <div style={{ marginTop: '3vh' }}>
                    <ProductsLoader
                        onComplete={() => props.onSetupComplete?.()}
                        onCachePopulated={() => {
                            displayOnlyOrchestrator
                                .populateDisplayState()
                                .then(() => {})
                                .catch(() => {});
                        }}
                    />
                </div>
            )}
        </BaseServiceScreen>
    );
};

export default DisplayOnlyLoadingScreen;
